module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"saveButtonLabel":"Speichern","cancelButtonLabel":"Abbrechen","deleteConfirmation":"Wollen Sie dieses Ziel wirklich löschen?","duplicateYearErrorMessage":"Jahr bereits vergeben"}}')
  delete Component.options._Ctor
}
